import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { DialogProps } from "@saleor/types";
import classNames from "classnames";
import * as React from "react";

const useStyles = makeStyles(
  {
    buttonConfirm: {
      backgroundColor: "#FFD15C !important",
      marginLeft: "8px"
    },
    buttonDisabled: {
      backgroundColor: "#A1A1A1 !important"
    }
  },
  {
    name: "ReverseCancelDialog"
  }
);

interface ReverseCancelDialogProps extends DialogProps {
  onSubmit?: (revertReason: string) => void;
}

const ReverseCancelDialog: React.FC<ReverseCancelDialogProps> = ({
  open,
  onClose,
  onSubmit,
  ...rest
}) => {
  const classes = useStyles(rest);
  const [value, setValue] = React.useState("");

  const onCloseDialog = () => {
    onClose();
    setValue("");
  };

  const onSubmitDialog = async () => {
    try {
      await onSubmit(value);
      onClose();
      setValue("");
    } catch (error) {
      return null;
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onCloseDialog} maxWidth="xs" fullWidth>
        <DialogTitle>Reason for Reversal</DialogTitle>
        <DialogContent>
          <TextField
            multiline
            rows={6}
            value={value}
            onChange={e => setValue(e.target.value)}
            label="Enter reason here"
            fullWidth
          ></TextField>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={onCloseDialog}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onSubmitDialog}
            disabled={value ? false : true}
            className={classNames({
              [classes.buttonConfirm]: value,
              [classes.buttonDisabled]: !value
            })}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReverseCancelDialog;
